import TagIcon from "./TagIcon";

export default TagIcon;
